module.exports = __webpack_public_path__ + "static/media/plays.f7bea233.svg";